import { render, staticRenderFns } from "./TourHost.vue?vue&type=template&id=4bc12bf4&scoped=true&"
import script from "./TourHost.vue?vue&type=script&lang=js&"
export * from "./TourHost.vue?vue&type=script&lang=js&"
import style0 from "./TourHost.vue?vue&type=style&index=0&id=4bc12bf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc12bf4",
  null
  
)

export default component.exports